import React, {useState} from "react";
import {IntlProvider} from "react-intl";
import English from '../languages/en-us.json'
import Indonesia from '../languages/id.json'
import {flattenMessages} from "../utils/Utils";
import {LANG_EN} from "../constants";

export const Context = React.createContext();
// export const ProductCategoryContext = React.createContext();

let local = navigator.language;
if (localStorage.getItem('selected_lang') !== null) {
    local = localStorage.getItem('selected_lang');
}else{
    local = LANG_EN
}

let lang;
if (local.toLowerCase() === LANG_EN) {
    lang = English;
    localStorage.setItem('selected_lang', local)
} else {
    lang = Indonesia;
    localStorage.setItem('selected_lang', local)
}

const WrapperContext = (props) => {
    const [locale, setLocale] = useState(local);
    const [messages, setMessages] = useState(lang);

    const selectLang = (e) => {
        localStorage.setItem('selected_lang', e)
        setLocale(e)
        if (e === LANG_EN) {
            setMessages(English)
        } else {
            setMessages(Indonesia)
        }
    }

    return (
        <Context.Provider value={{locale, selectLang}}>
            <IntlProvider locale={locale} messages={flattenMessages(messages)}>
                {props.children}
            </IntlProvider>
        </Context.Provider>
    );
}

export default WrapperContext